import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import { Modal } from "../../common/Modal";
import * as actions from "../redux/PlatfromSettingAction";
import { AddBankForm } from "./AddBankForm";

export const AddBankDialog = ({ setSwalProps }) => {
  const { auth } = useAuth();
  const intl = useIntl();
  const formikRef = useRef();
  const fileInputRef = useRef();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const [imagePreview, setImagePreview] = useState();
  const platformSettingState = useSelector(
    ({ platformSetting }) => platformSetting,
    shallowEqual
  );

  const saveValues = (queryParams) => {
    const qrbankname = queryParams.file
      ? `${Date.now()}.${queryParams.file.name.split(".").at(-1)}`
      : "";

    const newQueryParams = {
      ...queryParams,
      qrbankname,
      agentid: auth.selagentid ?? auth.agentid,
      loginid: auth.selloginid ?? auth.loginid,
      projectid: auth.selprojectid ?? auth.projectid,
    };

    const formData = new FormData();
    formData.append("qrbankname", qrbankname);
    formData.append("image", queryParams.file);
    formData.append("jsonData", JSON.stringify(newQueryParams));

    dispatch(actions.addBankList(formData)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "addBankSuccess" }),
          onConfirm: () => {
            if (fileInputRef.current) fileInputRef.current.value = "";
            setImagePreview(undefined);
            formikRef.current.resetForm();
            dismissBtnRef.current.click();
            const queryParams = {
              action: "masterbankaccountlist",
            };
            dispatch(actions.callBankList(queryParams));
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="addBankModal"
        title={intl.formatMessage({ id: "addBank" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          <AddBankForm
            formikRef={formikRef}
            fileInputRef={fileInputRef}
            saveValues={saveValues}
            imagePreview={imagePreview}
            setImagePreview={setImagePreview}
          />
        </div>
        <div className="p-3 d-flex justify-content-end align-items-center">
          {platformSettingState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button
            type="button"
            disabled={platformSettingState.actionsLoading}
            className="btn btn-primary px-3"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "add" })}
          </button>
        </div>
      </Modal>
    </div>
  );
};
